import { useMemo, useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useI18n } from '../../context/useI18n';
import AdminPlans from '../AdminPlans';
import AdminProgramInvites from '../AdminProgramInvites';
import { isFitLiveUiEnabled } from '../../utils/fitLiveModule';

const TABS = [
  { id: 'd28d', label: 'Planes gimnasio virtual' },
  { id: 'food', label: 'FOOD_PLAN' },
  { id: 'training', label: 'Plan Entrenadores' },
  { id: 'invites', label: 'Códigos por programa' },
];

export default function CommercialPlansHub({ onBack, onOpenVigencias, d28dOnly = false, trainingOnly = false }) {
  const { t } = useI18n();
  const hideD28d = isFitLiveUiEnabled();
  const [tab, setTab] = useState(trainingOnly ? 'training' : (hideD28d ? 'food' : 'd28d'));
  const visibleTabs = trainingOnly
    ? TABS.filter((item) => item.id === 'training')
    : (d28dOnly ? TABS.filter((item) => item.id === 'd28d') : TABS.filter((item) => !(hideD28d && item.id === 'd28d')));

  const inner = useMemo(() => {
    if (tab === 'food') {
      return (
        <AdminPlans
          mode="food"
          singlePlanOnly
          title="Plan comercial — FOOD_PLAN"
          embedded
        />
      );
    }
    if (tab === 'training') {
      return (
        <AdminPlans
          mode="training"
          title="Plan comercial — Entrenadores"
          embedded
        />
      );
    }
    if (tab === 'invites') {
      return <AdminProgramInvites embedded />;
    }
    return (
      <AdminPlans
        mode="d28d"
        title="Planes gimnasio virtual (todos los programas)"
        embedded
      />
    );
  }, [tab]);

  return (
    <div className="dashboard-main-view surface-readable d28d-admin-surface space-y-6 notranslate" translate="no">
      <header className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          {onBack && (
            <button type="button" className="btn-secondary" onClick={onBack}>
              <ArrowLeft className="w-4 h-4 inline mr-1" />
              {t('panel.back_services', 'Volver')}
            </button>
          )}
          <div>
            <h2 className="text-2xl font-bold text-stone-900">Planes y licencias</h2>
            <p className="text-sm text-stone-600">
              {trainingOnly
                ? 'Planes comerciales de entrenamiento (Wompi usuario final y activación de coaches marca blanca).'
                : 'Oferta comercial centralizada (Food y Entrenadores). No mezcla operación ni Zoom.'}
            </p>
          </div>
        </div>
        {onOpenVigencias && (
          <button type="button" className="btn-secondary" onClick={onOpenVigencias}>
            {t('nav.vigencias', 'Vigencias y pagos')}
          </button>
        )}
      </header>

      <div className="flex flex-wrap gap-2 border-b border-stone-200 pb-2">
        {visibleTabs.map((item) => (
          <button
            key={item.id}
            type="button"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              tab === item.id
                ? 'bg-lime-500 text-stone-900'
                : 'bg-stone-100 text-stone-700 hover:bg-stone-200'
            }`}
            onClick={() => setTab(item.id)}
          >
            {item.label}
          </button>
        ))}
      </div>

      {inner}
    </div>
  );
}
